import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { clearAuthTokens, clearUkekFromStorage } from '@/utils/sessionStorage';
import { clearAllModuleTimers } from '@/store/slices/poc/messagingSlice';
import { createLogger } from '@/utils/logger';

const log = createLogger({ namespace: 'six3ro:auth:logout' });

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const logoutThunk = createAppAsyncThunk<void>(
  'auth/logout',
  async(_, { getState, extra: { authService, pocServices } }) => {
    // 1. Revoke API access immediately — before any async work
    clearAuthTokens();

    // 2. Clear UKEK if we know the user
    const userId = getState().auth.userId;
    if (userId !== null) {
      clearUkekFromStorage(userId);
    } else {
      log.warn('No userId in state during logout — skipping UKEK cleanup');
    }

    // 3. Clear all module-level timers (pendingAcks, silence watchdogs, file list refreshes)
    clearAllModuleTimers();

    // 4. Shut down P2P stacks — must not abort logout if this fails
    try {
      await pocServices.p2pStackManagerService.shutdownAllStacks();
    } catch (error) {
      log.warn('P2P shutdown failed during logout:', error);
    }

    // 5. Placeholder for future server-side invalidation
    await authService.logout();

    // 6. Hard reload to destroy all in-memory state
    window.location.href = '/login';
  }
);
